/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { replacePXinStringWithEM, boxShadow, animations } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// EDITABLE TEXT STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	editabletext: {
		border: 'none',
		// overflow: 'auto',
		outline: 'none',
		boxShadow: 'none',
		background: 'transparent',
		resize: 'none',
		fontSize: 'inherit',
		lineHeight: 'inherit',
		textAlign: 'inherit',
		color: 'inherit',
		width: '100%',
		height: 'auto',
		transition: 'box-shadow .2s linear 0s',
		overflow: 'hidden',
		whiteSpace: 'normal',
		cursor: 'text',
		'&:empty:not(:focus):before': {
		    content: 'attr(data-text)'
		}
	}
});